import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="container-x py-24 text-center" data-testid="payment-cancel">
      <XCircle className="w-16 h-16 mx-auto text-muted-foreground" strokeWidth={1.5} />
      <div className="font-serif text-4xl mt-4">Payment Cancelled</div>
      <p className="text-muted-foreground mt-2 mb-6">Your cart is still saved — you can complete the payment any time.</p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Link to="/checkout" className="btn-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest">Return to Checkout</Link>
        <Link to="/shop" className="btn-outline-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest">Continue Shopping</Link>
      </div>
    </div>
  );
}
